import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
const LOG_IN = 'flarum/forum/components/LogInModal';

/**
 * Log-in modal layout: "Запомнить меня · Забыли пароль?" on one line under the fields and a
 * compact "Нет аккаунта? Регистрация" line instead of the stacked footer. Only the markup
 * moves: the controls keep core's own streams and handlers (remember, forgotPassword, signUp).
 */
export default function addAuthLayout() {
  extend(LOG_IN, 'fields', function (items) {
    if (!items.has('remember')) return;
    items.setContent('remember', m("div", {
      className: "Form-group TpAuth-options"
    }, m("label", {
      className: "checkbox TpCheckbox"
    }, m("input", {
      type: "checkbox",
      bidi: this.remember,
      disabled: this.loading
    }), m("span", null, app.translator.trans('core.forum.log_in.remember_me_label'))), m(Button, {
      className: "Button Button--text Button--link TpAuth-forgot",
      type: "button",
      onclick: this.forgotPassword.bind(this)
    }, app.translator.trans('core.forum.log_in.forgot_password_link'))));
  });
  override(LOG_IN, 'footer', function () {
    if (!app.forum.attribute('allowSignUp')) return null;
    return m("p", {
      className: "TpAuth-switch"
    }, m("span", null, app.translator.trans('tarotportal-theme.forum.auth.no_account')), m(Button, {
      className: "Button Button--text Button--link",
      type: "button",
      onclick: this.signUp.bind(this)
    }, app.translator.trans('core.forum.header.sign_up_link')));
  });

  // A second password email within core's throttle window (HTTP 429) says that, instead of core's
  // generic "you are posting too often": in "Забыли пароль?" (its own alert) and "Изменить пароль"
  // (the page alert). Core's request, throttle and responses are unchanged.
  const throttledReset = error => error?.status === 429 && /\/forgot$/.test(error.options?.url || '');
  const throttledText = () => app.translator.trans('tarotportal-theme.forum.auth.reset_throttled');
  override('flarum/forum/components/ForgotPasswordModal', 'onerror', function (original, error) {
    if (throttledReset(error) && error.alert) error.alert.content = throttledText();
    return original(error);
  });
  override(app, 'requestErrorDefaultHandler', function (original, error) {
    if (throttledReset(error) && error.alert) error.alert.content = throttledText();
    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }
    return original(error, ...args);
  });
}